namespace $.$$ {
	let $shm_hitalama_map_widget_float_entity_field_settings_layer = 1_000_000
	const $shm_hitalama_map_widget_float_entity_field_pointer_events = new WeakSet< PointerEvent >()

	export class $shm_hitalama_map_widget_float_entity_field_settings extends $.$shm_hitalama_map_widget_float_entity_field_settings {

		override showed( next?: boolean ) {
			if( next === true ) this.opened( true )
			return super.showed( next )
		}

	}

	export class $shm_hitalama_map_widget_float_entity_field extends $.$shm_hitalama_map_widget_float_entity_field {

		override pointerdown( event: PointerEvent ) {
			this.content_pointerdown( event )
		}

		override content_pointerdown( event: PointerEvent ) {
			if( $shm_hitalama_map_widget_float_entity_field_pointer_events.has( event ) ) return
			$shm_hitalama_map_widget_float_entity_field_pointer_events.add( event )
			if( this.fullscreen_attr() ) return
			if( this.locked() ) {
				this.selected( true )
				return
			}

			const target = event.target as Element
			const field_title = this.Field_title().dom_node()
			if( this.skip_drag( target ) && !field_title.contains( target ) ) {
				this.selected( true )
				return
			}

			this.Map_page().selected_links([ this.widget().link() ])
			this.drag_pointerdown( event )
		}

		field() {
			const atom = this.widget().Entity_field()
			const field = atom?.remote() ?? ( atom?.val()
				? $giper_baza_glob.Pawn( atom.val()!, $shm_hitalama_map_widget_entity_table2_field )
				: null )
			if( !field ) throw new Error( 'Свойство не связано с полем сущности' )
			return field
		}

		dataset() {
			const dataset = this.field().dataset()
			if( !dataset ) throw new Error( 'Поле не принадлежит сущности' )
			return dataset
		}

		settings_z_index() {
			return this.settings_layer() ? String( this.settings_layer() ) : ''
		}

		field_name( next?: string ) {
			const field = this.field()
			if( next === undefined ) return field.title()
			next = next.trim()
			if( !next || next === field.title() ) return field.title()
			const dataset = this.dataset()
			dataset.fields_write( dataset.fields().map( item => ({
				name: item.link().str === field.link().str ? next! : item.title(),
				type: item.type(),
				required: item.required(),
				tags: item.tags(),
			}) ) )
			return next
		}

		type_dictionary(): Record< string, string > {
			return {
				any: 'Любое значение',
				string: 'Строка',
				textarea: 'Многострочный текст',
				number: 'Число',
				date: 'Дата',
				period: 'Период',
				file: 'Файл',
				file_pb: 'Файл PocketBase',
				atom_link: 'Связь',
				list_link: 'Список связей',
				select: 'Выбор',
				json: 'JSON',
				custom: 'Вычисляемое',
			}
		}

		field_type( next?: string ) {
			const field = this.field()
			if( next === undefined ) return field.type()
			if( next === field.type() ) return next
			this.dataset().field_type_set( field.title(), next as $shm_hitalama_map_widget_entity_table2_field_type )
			return next
		}

		field_required( next?: boolean ) {
			const field = this.field()
			if( next === undefined ) return field.required()
			if( next === field.required() ) return next
			const dataset = this.dataset()
			dataset.fields_write( dataset.fields().map( item => ({
				name: item.title(),
				type: item.type(),
				required: item.link().str === field.link().str ? next! : item.required(),
				tags: item.tags(),
			}) ) )
			return next
		}

		field_type_title() {
			return this.type_dictionary()[ this.field_type() ] ?? this.field_type()
		}

		settings_opened( next?: boolean ) {
			if( next !== true ) return false
			this.settings_layer( ++$shm_hitalama_map_widget_float_entity_field_settings_layer )
			return true
		}

		is_relation() {
			return this.field().type() === 'atom_link' || this.field().type() === 'list_link'
		}

		relation_summary_visible() {
			return this.is_relation() ? super.relation_summary_visible() : []
		}

		target_settings() {
			return this.is_relation() ? super.target_settings() : []
		}

		inverse_settings() {
			return this.is_relation() && this.field().target_dataset() ? super.inverse_settings() : []
		}

		dataset_title( dataset: $shm_hitalama_map_widget_entity_table2_dataset ) {
			const widgets = this.map().Widgets_list()?.remote_list() ?? []
			return widgets.find( widget =>
				widget.type() === 'entity' && widget.Dataset()?.remote()?.link().str === dataset.link().str
			)?.title() ?? widgets.find( widget =>
				widget.type() === 'table2' && widget.Dataset()?.remote()?.link().str === dataset.link().str
			)?.title() ?? dataset.link().str
		}

		target_dictionary() {
			return Object.fromEntries([
				[ '', 'Не выбрана' ],
				... ( this.map().Datasets()?.remote_list() ?? [] ).map( dataset => [ dataset.link().str, this.dataset_title( dataset ) ] ),
			])
		}

		target_id( next?: string ) {
			const field = this.field()
			if( next === undefined ) return field.target_dataset()?.link().str ?? ''
			const dataset = this.dataset()
			if( field.inverse_field() ) dataset.field_inverse_pair( field, null )
			const target = next
				? ( this.map().Datasets()?.remote_list() ?? [] ).find( item => item.link().str === next ) ?? null
				: null
			field.target_dataset( target )
			return target?.link().str ?? ''
		}

		inverse_dictionary() {
			const field = this.field()
			const target = field.target_dataset()
			if( !target ) return { '': 'Не выбрано' }
			return Object.fromEntries([
				[ '', 'Не выбрано' ],
				... target.fields().filter( candidate => {
					if( candidate.type() !== 'atom_link' && candidate.type() !== 'list_link' ) return false
					if( candidate.inverse_field() && candidate.inverse_field()?.link().str !== field.link().str ) return false
					const back = candidate.target_dataset()
					return !back || back.link().str === this.dataset().link().str
				} ).map( candidate => [ candidate.link().str, candidate.title() ] ),
			])
		}

		inverse_id( next?: string ) {
			const field = this.field()
			if( next === undefined ) return field.inverse_field()?.link().str ?? ''
			const target = field.target_dataset()
			const inverse = next ? target?.fields().find( candidate => candidate.link().str === next ) ?? null : null
			this.dataset().field_inverse_pair( field, inverse )
			return inverse?.link().str ?? ''
		}

		relation_summary() {
			const target = this.field().target_dataset()
			return target ? `→ ${ this.dataset_title( target ) }` : '→ не выбрана'
		}

		override Tools() {
			const tools = super.Tools()
			tools.delete = ()=> {
				this.delete_asked( true )
				this.Field_settings().showed( true )
			}
			return tools
		}

		delete_controls() {
			return this.delete_asked()
				? [ this.Delete_confirm(), this.Delete_cancel() ]
				: [ this.Delete_ask() ]
		}

		field_delete_ask( event?: Event | null ) {
			if( event === undefined ) return null
			this.delete_asked( true )
			return event
		}

		@ $mol_action
		field_delete_confirm( event?: Event | null ) {
			if( event === undefined ) return null
			const field = this.field()
			const dataset = this.dataset()
			dataset.fields_write( dataset.fields().filter( item => item.link().str !== field.link().str ).map( item => ({
				name: item.title(), type: item.type(), required: item.required(), tags: item.tags(),
			}) ) )
			this.delete_asked( false )
			this.Field_settings().showed( false )
			return event
		}

		field_delete_cancel( event?: Event | null ) {
			if( event === undefined ) return null
			this.delete_asked( false )
			return event
		}

	}

}
